import { useNavigate } from "react-router-dom";

// Ekstra Temizlik onay zinciri: talep (GM) → iş emri onayı (proje ekibi) → taşeronda → şube son onayı → onaylı
export const FLOW_STAGE = {
  gm: ["GM ONAYI BEKLİYOR", "bg-red-600 text-white", (id) => `/onaylar?bekleyen=gm&kayit=${id}`],
  is_emri: ["İŞ EMRİ ONAYI BEKLİYOR", "bg-orange-500 text-white", (id) => `/is-emirleri?sekme=is_emri&kayit=${id}`],
  taseron: ["TAŞERONDA", "bg-sky-600 text-white", (id) => `/is-emirleri?sekme=pending&kayit=${id}`],
  sube: ["ŞUBE SON ONAYI BEKLİYOR", "bg-violet-600 text-white", (id) => `/onaylar?bekleyen=sube&kayit=${id}`],
  rejected: ["REDDEDİLDİ", "bg-red-100 text-red-800 border border-red-300", (id) => `/onaylar?sekme=rejected&kayit=${id}`],
  done: ["ONAYLI", "bg-emerald-100 text-emerald-800", (id) => `/onaylar?sekme=approved&kayit=${id}`],
};
export const FLOW_NEED = { gm: "GM onayı", is_emri: "iş emri onayı (proje ekibi)", taseron: "taşeronun işi tamamlaması" };
const LEGACY = { pending: ["ONAY BEKLİYOR", "bg-amber-100 text-amber-800"], approved: ["ONAYLI", "bg-emerald-100 text-emerald-800"], rejected: ["REDDEDİLDİ", "bg-red-100 text-red-800"] };

// tıklayınca eksik onayın bulunduğu ekran
export const flowTarget = (e) => {
  if (e.flow) return FLOW_STAGE[e.flow_stage || "gm"]?.[2](e.id);
  if (e.approval_status === "pending") return `/onaylar?bekleyen=${e.gm_approved ? "sube" : "gm"}&kayit=${e.id}`;
  if (e.approval_status === "rejected") return `/onaylar?sekme=rejected&kayit=${e.id}`;
  if (e.approval_status === "approved") return `/onaylar?sekme=approved&kayit=${e.id}`;
  return null;
};

export function FlowBadge({ e, hideSub = false }) {
  const navigate = useNavigate();
  const to = flowTarget(e);
  if (!to) return null;
  const go = (ev) => { ev.stopPropagation(); navigate(to); };
  if (e.flow) {
    const st = e.flow_stage || "gm";
    const [label, cls] = FLOW_STAGE[st] || FLOW_STAGE.gm;
    return (
      <button type="button" onClick={go} data-testid={`entry-appr-${e.id}`} data-stage={st} title={`${e.reject_reason ? `Red: ${e.reject_reason} — ` : ""}Onay adımına git`}
        className={`ml-1.5 px-1.5 py-0.5 rounded text-[9px] font-bold whitespace-nowrap hover:opacity-80 ${cls}`}>
        {st === "taseron" && hideSub ? "WILCO'DA" : label}
      </button>
    );
  }
  const [label, cls] = LEGACY[e.approval_status];
  return (
    <>
      <button type="button" onClick={go} data-testid={`entry-appr-${e.id}`} title={`${e.reject_reason ? `Red: ${e.reject_reason} — ` : ""}Onay ekranına git`} className={`ml-1.5 px-1.5 py-0.5 rounded text-[9px] font-bold whitespace-nowrap hover:opacity-80 ${cls}`}>{label}</button>
      {e.approval_status === "pending" && (
        <span className="ml-1 inline-flex items-center gap-0.5 text-[9px] font-bold whitespace-nowrap" data-testid={`entry-appr-sides-${e.id}`} title={`GM onayı: ${e.gm_approved ? "verildi" : "bekliyor"} · Şube onayı: ${e.sube_approved ? "verildi" : "bekliyor"}`}>
          <span className={e.gm_approved ? "text-emerald-700" : "text-red-700"}>GM {e.gm_approved ? "✓" : "✗"}</span><span className="text-slate-400">·</span><span className={e.sube_approved ? "text-emerald-700" : "text-red-700"}>ŞB {e.sube_approved ? "✓" : "✗"}</span>
        </span>
      )}
    </>
  );
}
